/* eslint-disable import/prefer-default-export */
import { pythonAxios } from './http';

export const getInsightsByJobIdApi = ({ params = {}, id } = {}) =>
  pythonAxios.get(`/insights/${id}`, {
    params,
  });
